import { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import { useTranslate } from "src/locales";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";
import DiagnosticPanel from "../diagnostic-category-weight-scores-panel";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import { OtherPrivilegeGuard } from "src/utils/authorization/OtherPrivilegeGuard";

//CKAPISIZ;446187;17032025

interface ApacheIIScoreProps {
  extraAccess?: boolean;
}

function ApacheIIScore({ extraAccess }: ApacheIIScoreProps) {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
    "success"
  );

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    fetchPatientData();
  }, []);

  const handleCreateMedcardData = async () => {
    try {
      const response = "Medcard Eklendi";
      console.log("Create API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Create API Hatası:", error);
      showAlert("Medcard eklenirken hata oluştu!", "error");
    }
  };

  const handleSaveMedcard = async () => {
    try {
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  const [DiagnosticPanelOpen, setDiagnosticPanelOpen] = useState(false);

  const handleOpenDiagnosticPanel = () => {
    setDiagnosticPanelOpen(true);
  };

  const handleCloseDiagnosticPanel = () => {
    setDiagnosticPanelOpen(false);
  };

  const getLaboratoryResults = () => {
    console.log("Laboratuvar Sonuçları Getirildi");
  };

  const calculate = () => {
    console.log("Hesaplandı");
  };

  const fetchPatientData = async () => {
    try {
      const response = "Hasta verileri getirildi.";
      console.log("Patient Data:", response);
    } catch (error) {
      console.error("Hata:", error);
    }
  };

  const { t } = useTranslate();

  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <OtherPrivilegeGuard
          extraAccess={extraAccess}
          fallback={<ByzNurseSaveButton disabled />}
        >
          <ByzNurseSaveButton onClick={handleSaveMedcard}></ByzNurseSaveButton>
        </OtherPrivilegeGuard>

        <OtherPrivilegeGuard
          extraAccess={extraAccess}
          fallback={<ByzNurseDeleteButton disabled />}
        >
          <ByzNurseDeleteButton onClick={handleDeleteMedcard}></ByzNurseDeleteButton>
        </OtherPrivilegeGuard>
        <ByzNursePrintButton2></ByzNursePrintButton2>
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={6} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography
                sx={{
                  fontSize: "14.41px",
                }}
              >
                {t("apacheii-score.calculate-expected-adjusted-mortality-rate")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("datetime")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("createdby")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  disabled
                  label={t("createdby")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("mother-fall-risk-assessment.parameters")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.has-acute-renal-failure")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.mean-blood-pressure")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.heart-rate")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.respiratory-rate")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    gap: "0px",
                    justifyContent: "space-between",
                  }}
                >
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      textAlign: "right",
                      justifyContent: "center",
                      fontSize: "13.9px",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.alveolar-arterial-oxygen-gradient")}
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{ fontSize: "30px", fontWeight: "100", margin: "auto" }}
                  >
                    |
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "right",
                      fontSize: "13.4px",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.oxygen-pressure-mmhg")}
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{ fontSize: "30px", fontWeight: "100", margin: "auto" }}
                  >
                    |
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "right",
                      fontSize: "13.4px",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.oxygen-pressure-kpa")}
                  </ByzMuiTypography>
                </Stack>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} variant="outlined" />
                    )}
                    options={[]}
                    sx={{ width: "100%", maxWidth: "300px" }}
                    color="info"
                    label={t("select", "uppercase")}
                    placeholder={t("select", "uppercase")}
                  />
                  <ByzMuiTextField
                    sx={{ width: "250px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "250px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.alveolar-arterial-oxygen-gradient")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.partial-oxygen-pressure")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.chronic-organ-failure")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.glasgow-score")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("score")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.point")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.apache-ii-score")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("score")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.expected-mortality-rate")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  backgroundColor: "#F4F7FE",
                }}
              >
                <ByzMuiTypography>
                  {t("apacheii-score.laboratory-results")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiButton
                  variant="outlined"
                  color="primary"
                  onClick={getLaboratoryResults}
                  sx={{
                    width: "300px",
                    height: "50px",
                    backgroundColor: "#63B4FF33",
                  }}
                >
                  {t("apacheii-score.fetch-laboratory-results")}
                </ByzMuiButton>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.serum-hco3-if-no-akg")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.arterial-ph")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.serum-sodium")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.serum-potassium")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.serum-creatinine")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.hematocrit")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.white-blood-cell-count")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.age")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("apacheii-score.calculate-oxygen")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    gap: "0px",
                    justifyContent: "space-between",
                  }}
                >
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      textAlign: "right",
                      justifyContent: "center",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.partial-carbon-dioxide-pressure-mmhg")}
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{ fontSize: "30px", fontWeight: "100", margin: "auto" }}
                  >
                    |
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "right",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.partial-carbon-dioxide-pressure-kpa")}
                  </ByzMuiTypography>
                </Stack>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "350px" }}
                    color="info"
                    label={t("apacheii-score.result")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    gap: "0px",
                    justifyContent: "space-between",
                  }}
                >
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      textAlign: "right",
                      justifyContent: "center",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.partial-oxygen-pressure-mmhg")}
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{ fontSize: "30px", fontWeight: "100", margin: "auto" }}
                  >
                    |
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "right",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.partial-oxygen-pressure-kpa")}
                  </ByzMuiTypography>
                </Stack>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "350px" }}
                    color="info"
                    label={t("apacheii-score.result")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    gap: "0px",
                    justifyContent: "space-between",
                  }}
                >
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      textAlign: "right",
                      justifyContent: "center",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.partial-oxygen-pressure-mmhg")}
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{ fontSize: "30px", fontWeight: "100", margin: "auto" }}
                  >
                    |
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "right",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.fraction-ofi-nspired-oxygen-kpa")}
                  </ByzMuiTypography>
                </Stack>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.procedure")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiButton
                  variant="outlined"
                  color="primary"
                  onClick={calculate}
                  sx={{
                    width: "300px",
                    height: "50px",
                    backgroundColor: "#63B4FF33",
                  }}
                >
                  {t("apacheii-score.calculate")}
                </ByzMuiButton>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    gap: "0px",
                    justifyContent: "space-between",
                  }}
                >
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      textAlign: "right",
                      justifyContent: "center",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.alveolar-arterial-oxygen-gradient-mmhg")}
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{ fontSize: "30px", fontWeight: "100", margin: "auto" }}
                  >
                    |
                  </ByzMuiTypography>
                  <ByzMuiTypography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "right",
                      margin: "auto",
                    }}
                  >
                    {t("apacheii-score.alveolar-arterial-oxygen-gradient-kpa")}
                  </ByzMuiTypography>
                </Stack>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                  <ByzMuiTextField
                    sx={{ width: "300px" }}
                    color="info"
                    label={t("apacheii-score.enter")}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography
                sx={{
                  fontSize: "14.41px",
                }}
              >
                {t("apacheii-score.calculate-expected-adjusted-mortality-rate")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.diagnostic-category-weight")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack direction="row" spacing={2} sx={{ width: "300px" }}>
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} variant="outlined" />
                    )}
                    options={[]}
                    sx={{
                      width: "100%",
                      maxWidth: "300px",
                    }}
                    color="info"
                    label={t("select", "uppercase")}
                    placeholder={t("select", "uppercase")}
                  />
                  <ByzMuiButton
                    variant="outlined"
                    color="primary"
                    onClick={handleOpenDiagnosticPanel}
                    sx={{
                      width: "150px",
                      height: "50px",
                      backgroundColor: "#63B4FF33",
                      borderRadius: "20px",
                      padding: "0px",
                    }}
                  >
                    {t("apacheii-score.choose")}
                  </ByzMuiButton>
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("apacheii-score.expected-adjusted-mortality-rate")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={
                alertSeverity === "success"
                  ? t("operation-successful")
                  : t("error")
              }
              message={alertMessage}
              type={alertSeverity}
            />
          </Grid>
        </Grid>
      </Box>

      <OpenComponentDialog
        open={DiagnosticPanelOpen}
        onClose={handleCloseDiagnosticPanel}
        title={t("apacheii-score.diagnostic-category-severity-scores")}
      >
        <DiagnosticPanel />
      </OpenComponentDialog>
    </>
  );
}

export default ApacheIIScore;
